import { render, staticRenderFns } from "./ControlledSubstances.vue?vue&type=template&id=197b0942&"
import script from "./ControlledSubstances.vue?vue&type=script&lang=js&"
export * from "./ControlledSubstances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports